import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export interface DorucenkaDocument {
  id: number;
  reservationId: number;
  /** Slot index of the guest member, or null when submitted as a whole-reservation batch. */
  slotIndex: number | null;
  pseudoRazitko: string | null;
  uploadedAt: string;
  expiresAt: string;
}

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
});

export const getDorucenky = async (reservationId: number): Promise<DorucenkaDocument[]> => {
  const res = await axios.get(`${API_BASE}/reservations/${reservationId}/dorucenky`, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });
  return res.data;
};

/** Fetches a presigned S3 URL from the backend and opens it in a new tab. */
export const downloadDorucenka = async (reservationId: number, docId: number): Promise<void> => {
  const res = await axios.get<{ url: string }>(
    `${API_BASE}/reservations/${reservationId}/dorucenky/${docId}/download`,
    { headers: getAuthHeaders(), withCredentials: true }
  );
  window.open(res.data.url, '_blank');
};

/** Triggers a ZIP download of all Dorucenky for one reservation. */
export const downloadAllDorucenky = async (reservationId: number): Promise<void> => {
  const res = await fetch(`${API_BASE}/reservations/${reservationId}/dorucenky/download-all`, {
    headers: getAuthHeaders(),
  });
  const blob = await res.blob();
  triggerBlobDownload(blob, `dorucenky-reservation-${reservationId}.zip`);
};

/** Triggers a ZIP download of Dorucenky for multiple reservations. */
export const downloadMultiReservationDorucenky = async (reservationIds: number[]): Promise<void> => {
  const res = await fetch(`${API_BASE}/reservations/dorucenky/download-multi`, {
    method: 'POST',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ reservationIds }),
  });
  const blob = await res.blob();
  triggerBlobDownload(blob, 'dorucenky.zip');
};

function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
